import classNames from 'classnames';
import React from 'react';
import { Anchor, Divider, Icons, OffCanvas } from '@miro-site/ui-foundation';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var Drawer = function Drawer(_ref) {
  var backdropClassName = _ref.backdropClassName,
      children = _ref.children,
      className = _ref.className,
      handleBack = _ref.handleBack,
      currentMenuPath = _ref.currentMenuPath,
      handleClose = _ref.handleClose,
      show = _ref.show,
      title = _ref.title;
  return /*#__PURE__*/_jsxs(OffCanvas, {
    className: classNames('border-0', className),
    backdropClassName: backdropClassName,
    show: show,
    handleClose: handleClose,
    children: [/*#__PURE__*/_jsxs(OffCanvas.Header, {
      className: "px-300",
      children: [/*#__PURE__*/_jsxs("div", {
        className: "d-flex align-items-center gap-150",
        children: [!!(currentMenuPath !== null && currentMenuPath !== void 0 && currentMenuPath.length) && /*#__PURE__*/_jsx(Anchor, {
          size: "md",
          circularBg: true,
          withHoverBg: true,
          onClick: handleBack,
          children: /*#__PURE__*/_jsx(Icons.ChevronLeft, {
            size: "md"
          })
        }), /*#__PURE__*/_jsx(OffCanvas.Title, {
          children: title
        })]
      }), /*#__PURE__*/_jsx(Anchor, {
        size: "md",
        circularBg: true,
        withHoverBg: true,
        onClick: handleClose,
        children: /*#__PURE__*/_jsx(Icons.Cross, {
          size: "md"
        })
      })]
    }), /*#__PURE__*/_jsx(Divider, {
      light: true
    }), /*#__PURE__*/_jsx(OffCanvas.Body, {
      className: "py-400 px-300",
      children: children
    })]
  });
};